/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ParticipatedInputs */

const en__field_participated = /** @type {(inputs: _Field_ParticipatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participated`)
};

const de__field_participated = /** @type {(inputs: _Field_ParticipatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen`)
};

/**
* | output |
* | --- |
* | "Participated" |
*
* @param {_Field_ParticipatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_participated = /** @type {((inputs?: _Field_ParticipatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ParticipatedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_participated(inputs)
	return de__field_participated(inputs)
});